
import axios from 'axios';

// Recupera un film tramite SKU
export const getFilmBySku = async (sku) => {
    try {
        const response = await api.get(`/film/by-sku/${encodeURIComponent(sku)}`);
        return response.data;
    } catch (error) {
        console.error(`Errore nel recupero film per SKU ${sku}:`, error);
        throw error;
    }
};

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
    baseURL: `${API_URL}/api`,
    paramsSerializer: {
        indexes: null // Serializza array come sort=val1&sort=val2 invece di sort[]=val1
    }
});

// Interceptor per aggiungere il token JWT a tutte le richieste autorizzate
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('access_token');
        if (token) {
            // Se un token esiste, aggiungilo all'header Authorization
            // Non controlliamo !config.headers.Authorization perché l'interceptor
            // dovrebbe sempre impostare o sovrascrivere l'header se un token è disponibile.
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Interceptor per gestire le risposte, in particolare gli errori 401
api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            // Se si verifica un 401, reindirizza al login
            // Importiamo il contesto di autenticazione in modo lazy o usiamo window.location
            // Per evitare dipendenze circolari in api.js, usiamo localStorage e navigate diretti
            localStorage.removeItem('access_token');
            // Il reindirizzamento deve avvenire tramite un meccanismo di routing
            // o ricaricando la pagina. Usare window.location.href è il metodo più semplice qui
            // ma in un'applicazione React più complessa si preferirebbe usare useNavigate
            // dalla componente principale o dal contesto.
            window.location.href = '/login'; // Reindirizza al login
        }
        return Promise.reject(error);
    }
);

export const loginUser = async (email, password) => {
    try {
        const response = await api.post('/auth/token', new URLSearchParams({
            username: email,
            password: password
        }), {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
        return response.data;
    } catch (error) {
        if (error.response && error.response.status === 401) {
            throw new Error('Credenziali non valide');
        }
        throw error;
    }
};

export const refreshToken = async () => {
    try {
        const response = await api.post('/auth/refresh-token');
        return response.data;
    } catch (error) {
        console.error('Errore nel refresh del token:', error);
        throw error;
    }
};

// --- Esempio di altre chiamate API (puoi aggiungere qui tutte le tue funzioni CRUD) ---

export const getDatiAzienda = async () => {
    try {
        const response = await api.get('/dati-azienda');
        return response.data;
    } catch (error) {
        console.error('Error fetching dati azienda:', error);
        throw error;
    }
};

export const updateDatiAzienda = async (data) => {
    const formData = new FormData();
    for (const key in data) {
        if (key === 'logo_file' && data[key]) {
            formData.append('logo_file', data[key]);
        } else if (key !== 'logo_url') { // Avoid sending logo_url directly if logo_file is sent
            formData.append(key, data[key]);
        }
    }

    try {
        const response = await api.put('/dati-azienda', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error updating dati azienda:', error);
        throw error;
    }
};

export const getUsers = async () => {
    try {
        const response = await api.get('/admin/users');
        return response.data;
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error;
    }
};

export const createUser = async (userData) => {
    try {
        const response = await api.post('/admin/users', userData);
        return response.data;
    } catch (error) {
        console.error('Error creating user:', error);
        throw error;
    }
};

export const updateUser = async (userId, userData) => {
    try {
        const response = await api.put(`/admin/users/${userId}`, userData);
        return response.data;
    } catch (error) {
        console.error(`Error updating user ${userId}:`, error);
        throw error;
    }
};

export const deleteUser = async (userId) => {
    try {
        const response = await api.delete(`/admin/users/${userId}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting user ${userId}:`, error);
        throw error;
    }
};


export default api; // Esporta l'istanza di Axios configurata per usi futuri
